export const buildQueryString = (params: Record<string, string>): string => {
  const esc = encodeURIComponent;
  return Object.keys(params)
    .map((key) => `${esc(key)}=${esc(params[key])}`)
    .join('&');
};
